// extracted by mini-css-extract-plugin
var _1 = "dark-mode";
var _2 = "PKfMLeajJfdWl6pYoCww";
var _3 = "sIcfltfwVGTHp2bzntpO";
export { _1 as "dark-mode", _2 as "label", _3 as "lineThrough" }
